import {Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {TableUserInfo} from '@components/common/users-table/users-table'
import {UsersTableUtil} from '@components/common/users-table/users-table-util'
import {UserAccess} from '@extensions/user-access'

// TODO! should be in a common place
export const getUsers = (board: Hub): TableUserInfo[] => {
  const box = Sync.getCurrentSandbox()
  return UserAccess.listUsersInProject({
    companyId: board.companyId,
    id: board.location
  }).map(x => UsersTableUtil.convertUser(box, x))
}
